module.exports = __webpack_public_path__ + "img/app-store-apple-logo.5c684a08.jpg";